import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  min-width: ", ";\n  text-align: center;\n  text-transform: ", ";\n  white-space: nowrap;\n\n  ", "\n\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 1px;\n    color: ", ";\n    font-size: 10px;\n    font-weight: ", ";\n    line-height: ", ";\n    padding: 1px ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: ", ";\n    color: ", ";\n    font-size: 12px;\n    font-weight: ", ";\n    height: ", ";\n    line-height: ", ";\n    padding: 1px ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: ", ";\n    color: ", ";\n    font-weight: ", ";\n    height: ", ";\n    line-height: ", ";\n    padding: 1px ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { color, typography } from '@scp/ui-shared/theme/variables';
import { lineHeight, baselineToRem } from '@scp/ui-shared/theme/utils';
var STYLES_BY_TYPE = {
  primary: css(_templateObject(), color.backgroundDark, baselineToRem(3), color.palette.grey900, typography.fontWeightSemiBold, baselineToRem(4), lineHeight(16), baselineToRem(3)),
  secondary: css(_templateObject2(), color.backgroundSecondary, baselineToRem(2), color.textSecondary, typography.fontWeightNormal, baselineToRem(4), lineHeight(16, 12), baselineToRem(3)),
  small: css(_templateObject3(), color.palette.grey800, color.textPrimary, typography.fontWeightBold, lineHeight(12, 10), baselineToRem(1))
};
var STYLES_BY_COLOR = {
  'light-red': css(_templateObject4(), color.palette.red900, color.palette.red450),
  'light-green': css(_templateObject5(), color.palette.green900, color.palette.green300),
  'light-purple': css(_templateObject6(), color.palette.purple900, color.palette.grey200),
  'light-grey': css(_templateObject7(), color.palette.grey800, color.palette.grey200),
  'light-blue': css(_templateObject8(), color.palette.blue100, color.palette.blue700),
  'light-yellow': css(_templateObject9(), color.palette.yellow900, color.palette.grey200)
};

var getMinWidth = function getMinWidth(_ref) {
  var minWidth = _ref.minWidth;

  if (typeof minWidth === 'number') {
    return baselineToRem(minWidth);
  }

  if (minWidth) {
    return baselineToRem(26);
  }

  return 'auto';
};
/**
 * @example ./__docs__/PillIndicator.md
 */


export var PillIndicator = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['color', 'type', 'minWidth', 'upperCase'].includes(prop);
  }
})(_templateObject10(), getMinWidth, function (props) {
  return props.upperCase ? 'uppercase' : 'none';
}, function (_ref2) {
  var secondary = _ref2.secondary,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'primary' : _ref2$type;
  var indicatorType = secondary ? 'secondary' : type;
  return STYLES_BY_TYPE[indicatorType];
}, function (_ref3) {
  var color = _ref3.color;
  return color ? STYLES_BY_COLOR[color] : null;
});